'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment', 'AVRO.Common.UserPreferences'];
module.exports = angular.module('AVRO.Fares.CommonChartComponents', dependencies).factory('CommonFaresChartComponentsService', require('./services/CommonFaresChartComponentsService'));